import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { ArrowIcon, LoupeIcon, NinjaIcon } from 'assets';
import { AuthHeading, Button, Spinner } from 'view/components';
import { AuthHeadingImageTypeEnums } from 'view/pages/auth/helpers';
import { useUpdateUserRole } from 'view/pages/auth/hooks/useUpdateUserRole';
import { theme } from 'view/themes/theme';
import * as CS from 'view/pages/auth/commonStyled';
import * as S from './styled';

const ROLE_JOB_SEEKER = 2;
const ROLE_TALENT_SEEKER = 3;
const rolesData = [
  {
    role: ROLE_JOB_SEEKER,
    icon: NinjaIcon,
    text: 'I am Looking for Job Opportunities',
  },
  {
    role: ROLE_TALENT_SEEKER,
    icon: LoupeIcon,
    text: 'I am Looking for Talent',
  },
];

const ChooseYourRolePage = () => {
  const matches = useMediaQuery(theme.breakpoints.down('tablet'));
  const [userRole, setUserRole] = useState<number>(ROLE_JOB_SEEKER);

  const { isLoading, updateUserRole } = useUpdateUserRole();

  const onHandleSubmit = () => {
    updateUserRole({ roleId: userRole });
  };

  return (
    <CS.Wrapper>
      <CS.AuthMainBox component="section" style={{ height: matches ? 'calc(100% - 2rem' : '100%' }}>
        <AuthHeading
          title="Set up your profile"
          subTitle={'Are you here to find your next opportunity \n or to discover great talent?'}
          imageType={AuthHeadingImageTypeEnums.LINE}
        />

        <CS.FormWrapper
          component="section"
          style={{
            height: matches ? '100%' : 'auto',
            justifyContent: matches ? 'space-between' : 'initial',
          }}
        >
          <CS.FormWrapperMain>
            {rolesData.map(({ role, icon: Icon, text }) => {
              return (
                <S.ChooseRoleItem
                  key={role}
                  onClick={() => {
                    return setUserRole(role);
                  }}
                  selected={userRole === role}
                >
                  <Icon isSelected={userRole === role} />
                  <S.ChooseRoleItemText>{text}</S.ChooseRoleItemText>
                  {userRole === role && <S.CheckIconCentered />}
                </S.ChooseRoleItem>
              );
            })}
          </CS.FormWrapperMain>
          <Button
            variant="contained"
            text="Create profile"
            disabled={isLoading}
            endIcon={
              isLoading ? (
                <Spinner disabled={isLoading} variant="contained" />
              ) : (
                <ArrowIcon rotate="right" color="white" />
              )
            }
            style={{ marginTop: '40px' }}
            onClick={onHandleSubmit}
          />
        </CS.FormWrapper>
      </CS.AuthMainBox>
    </CS.Wrapper>
  );
};

export default ChooseYourRolePage;
